$(function () {
  //判断是否是占卜产品
  if ($("#product_id_item").data("id") == 9010870255859) {
    let shopify_features_script = document.querySelector("script[id='shopify-features']");
    let shopify_features_json = JSON.parse(shopify_features_script.innerHTML);
    let variant_id = $(`input[name="id"]`).val();
    var checkout_headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'authorization': 'Basic ' + btoa(shopify_features_json.accessToken)
    };
    // Function to get cookie by name
    function getCookie(name) {
      var cookieArr = document.cookie.split(";");

      for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");

        if (name == cookiePair[0].trim()) {
          return decodeURIComponent(cookiePair[1]);
        }
      }

      return null;
    }

    // Get the userData cookie
    var userDataCookie = getCookie("userData");

    if (userDataCookie) {
      try {
        // Parse the JSON string
        var userData = JSON.parse(userDataCookie);
        sessionStorage.setItem(
          'userData',
          JSON.stringify(
            Object.assign(
              {},
              userData,
              {
                is_pay: '1',
              },
            )
          )
        );

        let checkout_json = {
          "checkout": {
            "line_items": [{
              "variant_id": variant_id,
              "quantity": 1,
              "properties": {
                "cartToken": userData.cart_token,
                "Username": userData.username,
                "Language": userData.language,
                "Gender": userData.gender == 1 ? 'Male' : 'Female',
                "Birthday": userData.birthday,
                "Home Place": userData.home_place.replace(/\+/g, " "),
                "Topics": userData.topics.replace(/\+/g, " ")
              }
            }],
            "secret": true,
            "wallet_name": "Checkout",
            "is_upstream_button": false,
            "page_type": "product",
            "has_selling_plans": false,
            "presentment_currency": "",
            "country": ""
          }
        }
        let data = JSON.stringify(checkout_json);
        fetch("/wallets/checkouts.json", {
          method: 'POST',
          headers: checkout_headers,
          body: data
        }).then(function (response) {
          if (response.ok) {
            return response.text();
          }
        }).then(function (strj) {
          let checkout_json = JSON.parse(strj);
          location.href = checkout_json.checkout.web_url;
        }).catch(function (err) {});
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    } else {
      console.log("userData cookie not found");
    }
  }
})